const HeroImage = {
  getSettings: componentSettings => ({
    ...componentSettings,
    modifier: 'hero-image'
  })
};

export default HeroImage;
